<template>
  <div class="dashboard-layout">
    <!-- Left Column - User Information (1/3) -->
    <div class="info-column">
      <UserInfo />
    </div>

    <!-- Right Column - Time Reporting Calendar (2/3) -->
    <div class="calendar-column">
      <TimeReporting />
    </div>
  </div>

  <!-- Custom Modal -->
</template>

<script setup>
import { useRouter } from 'vue-router'
import UserInfo from './UserInfo.vue'
import TimeReporting from './TimeReporting.vue'

const router = useRouter()
</script>

<style scoped>
.dashboard-layout {
  display: flex;
  min-height: 100vh;
  gap: 2rem;
  padding: 2rem;
}

.info-column {
  flex: 1;
  max-width: 33.333%;
}

.calendar-column {
  flex: 2;
  max-width: 66.667%;
}

/* Responsive */
@media (max-width: 1024px) {
  .dashboard-layout {
    flex-direction: column;
  }
  
  .info-column {
    display: none;
  }
  .calendar-column {
    max-width: 100%;
  }
}

/* Hide info column on mobile */
@media (max-width: 768px) {
  .info-column {
    display: none;
  }
  
  .calendar-column {
    flex: 1;
    max-width: 100%;
  }
  
  .dashboard-layout {
    padding: 1rem;
  }
}
</style>
